import { Progress } from '@agro-club/agroclub-shared'
import { isUS } from 'env'
import { DealStatusTypes } from 'modules/domain/deal/types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useDealBoardColumns = () => {
  const { t } = useTranslation('deal')
  const defaultColumns = [
    { statusDeal: DealStatusTypes.NEW, label: t('potentialDeals') },
    {
      statusDeal: DealStatusTypes.IN_PROGRESS,
      label: t('statuses.in_progress'),
    },
    { statusDeal: DealStatusTypes.CUSTOMER_NEGOTIATIONS, label: t('statuses.customer_negotiations') },
    { statusDeal: DealStatusTypes.AGREED, label: t('statuses.agreed') },
    { statusDeal: DealStatusTypes.CONTRACT_SIGNED, label: t('statuses.contract_signed') },
    { statusDeal: DealStatusTypes.PAYMENT_SHIPMENT, label: t('statuses.payment_shipment') },
    { statusDeal: DealStatusTypes.SHIPMENT_COMPLETE, label: t('statuses.shipment_complete') },
  ]
  if (isUS) {
    return [
      { statusDeal: DealStatusTypes.NEW, label: t('potentialDeals') },
      {
        statusDeal: DealStatusTypes.IN_PROGRESS,
        label: t('statuses.in_progress'),
      },
      { statusDeal: DealStatusTypes.AGREED, label: t('statuses.agreed') },
      { statusDeal: DealStatusTypes.CONTRACT_SIGNED, label: t('statuses.contract_signed') },
      { statusDeal: DealStatusTypes.CONFIRMED_BATCH, label: t('statuses.confirmed_batch') },
      { statusDeal: DealStatusTypes.PAYMENT_SHIPMENT, label: t('statuses.payment_shipment') },
      { statusDeal: DealStatusTypes.SHIPMENT_COMPLETE, label: t('statuses.shipment_complete') },
      { statusDeal: DealStatusTypes.DOCUMENTS_ACCEPTED, label: t('statuses.documents_accepted') },
      { statusDeal: DealStatusTypes.PAYMENT_COMPLETE, label: t('statuses.payment_complete') },
    ]
  }

  return defaultColumns
}

export const useColumnContentMargin = (elementId: string, progress) => {
  const [boundingTop, setBoundingTop] = useState(278)

  const updateBoundingTop = () => {
    const element = document.getElementById(elementId)
    const boundingRectTop = element?.getBoundingClientRect().top || 0
    setBoundingTop(boundingRectTop)
  }
  useEffect(() => {
    if (progress !== Progress.SUCCESS) return
    updateBoundingTop()
    window.addEventListener('resize', updateBoundingTop)
    return () => {
      window.removeEventListener('resize', updateBoundingTop)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [progress])
  return boundingTop
}
